import { activationSites as mockActivationSites } from '@/mocks/activationSites';
import type { ActivationSite, ActivationStatus } from '@/domain/types';
import { requireSupabase } from '@/lib/supabase';

export const activationSites: ActivationSite[] = mockActivationSites;

export function getActivationSitesByLicenseId(licenseId: string) {
  return activationSites.filter((site) => site.licenseId === licenseId);
}

export interface AdminActivation extends ActivationSite {
  productName: string;
}

type ActivationRow = {
  id: string;
  license_id: string;
  site_url: string;
  site_host: string;
  status: ActivationStatus;
  plugin_version: string | null;
  wp_version: string | null;
  php_version: string | null;
  activated_at: string;
  last_check_at: string;
  licenses?: { products?: { name?: string | null } | null } | null;
};

function mapActivation(row: ActivationRow): AdminActivation {
  return {
    id: row.id,
    licenseId: row.license_id,
    siteUrl: row.site_url,
    siteHost: row.site_host,
    status: row.status,
    pluginVersion: row.plugin_version ?? '',
    wpVersion: row.wp_version ?? '',
    phpVersion: row.php_version ?? '',
    activatedAt: row.activated_at,
    lastCheckAt: row.last_check_at,
    productName: row.licenses?.products?.name ?? '—',
  };
}

export async function listAdminActivations(): Promise<AdminActivation[]> {
  const supabase = requireSupabase();
  const { data, error } = await supabase
    .from('license_activations')
    .select('*, licenses!license_id(products!product_id(name))')
    .order('last_check_at', { ascending: false });

  if (error) throw error;
  return (data as ActivationRow[]).map(mapActivation);
}

export async function updateAdminActivationStatus(id: string, status: ActivationStatus): Promise<void> {
  const supabase = requireSupabase();
  const { error } = await supabase
    .from('license_activations')
    .update({ status })
    .eq('id', id);

  if (error) throw error;
}
